import { defineMessages } from 'react-intl'

export const careServicesSidePanelMessages = defineMessages({
  subtitle: {
    defaultMessage: 'Care services',
    description: 'Subtitle for the care services side-panel section',
  },
  manageTeam: {
    defaultMessage: 'Manage team',
    description: 'Link that opens the care team management flow for a program in the care services side-panel section',
  },
  viewPastCare: {
    defaultMessage: 'View past care',
    description: 'Link to the client past care history modal',
  },
  therapist: {
    defaultMessage: 'Therapist',
    description: 'Provider role label for a therapist',
  },
  psychiatrist: {
    defaultMessage: 'Psychiatrist',
    description: 'Provider role label for a psychiatrist',
  },
  prescriber: {
    defaultMessage: 'Prescriber',
    description: 'Provider role label for a prescriber',
  },
  coach: {
    defaultMessage: 'Coach',
    description: 'Provider role label for a coach',
  },
})
